import { createFileRoute, notFound } from "@tanstack/react-router";

import { DueDatePageView } from "../components/tools/due-date";
import { faqJsonLd } from "../components/tools/tool-layout";
import { DUE_DATE_PAGES, DUE_DATE_SLUGS } from "../lib/due-date-pages";
import { seo } from "../lib/head";

const bySlug = new Map(
  Object.entries(DUE_DATE_SLUGS).map(([method, slug]) => [
    slug,
    DUE_DATE_PAGES[method as keyof typeof DUE_DATE_SLUGS],
  ]),
);

export const Route = createFileRoute("/calcul-date-accouchement/$method")({
  staticData: { ssr: true },
  loader: ({ params }) => {
    const page = bySlug.get(params.method);
    if (!page) throw notFound();
    return page;
  },
  head: ({ loaderData: page }) =>
    page
      ? seo({ title: page.title, description: page.description, jsonLd: faqJsonLd(page.faq) })
      : {},
  component: DueDateMethodPage,
});

function DueDateMethodPage() {
  return <DueDatePageView page={Route.useLoaderData()} />;
}
